import { render, staticRenderFns } from "./indicator-sets.vue?vue&type=template&id=4ae74b27&scoped=true&"
import script from "./indicator-sets.vue?vue&type=script&lang=ts&"
export * from "./indicator-sets.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ae74b27",
  null
  
)

export default component.exports